import { render, staticRenderFns } from "./ParameterComparisonPanel.vue?vue&type=template&id=3241f9a0"
import script from "./ParameterComparisonPanel.vue?vue&type=script&lang=js"
export * from "./ParameterComparisonPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports